/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_TitleInputs */

const en_home_title = /** @type {(inputs: Home_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`U.S. Market Entry & Cross-Border Business Consulting | Iter Global Consulting`)
};

const pt_home_title = /** @type {(inputs: Home_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrada no Mercado dos EUA e Consultoria Empresarial Transfronteiriça | Iter Global Consulting`)
};

const es_home_title = /** @type {(inputs: Home_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrada al Mercado de EE. UU. y Consultoría Empresarial Transfronteriza | Iter Global Consulting`)
};

/**
* | output |
* | --- |
* | "U.S. Market Entry & Cross-Border Business Consulting \| Iter Global Consulting" |
*
* @param {Home_TitleInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const home_title = /** @type {((inputs?: Home_TitleInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_TitleInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_home_title(inputs)
	if (locale === "es") return es_home_title(inputs)
	return en_home_title(inputs)
});